module.exports = __webpack_public_path__ + "static/media/shopping-trolley.37c3a822.svg";